import React from "react";
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { MENUCATCODE, RECIPE_API_01, RECIPE_API_02, REPORT_API_01 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

const ViewRecipe = ({ open, onClose, data = [] }) => {
 const [ingredients, setIngredientsData] = useState([]); // ✅ Fix here



useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(RECIPE_API_02, "get", {
        MENUCATCODE: data?.menucatcode,
        MENUCODE: data?.menucode,
        STS: CON_STATUS_ACTIVE,
      });
      setIngredientsData(result || []);
    } catch (err) {
      setIngredientsData([]); // Clear ingredients on error
     
    }
  };

  if (data?.menucode && data?.menucatcode) {
    fetchData();
  } else {
    setIngredientsData([]); // Clear if no data
  }
}, [data?.menucode, data?.menucatcode]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>View Recipe : {data?.MENUNAME}</DialogTitle>
      <DialogContent dividers>
        
       
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>#</strong></TableCell>
                {/* <TableCell><strong>Product Code</strong></TableCell> */}
                <TableCell><strong>Product Name</strong></TableCell>
                {/* <TableCell><strong>Description</strong></TableCell> */}
                <TableCell align="center" className="text-right"><strong>Quantity</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ingredients.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  {/* <TableCell>{item.PRODUCTCODE}</TableCell> */}
                  <TableCell>{item.PRODUCTNAME}</TableCell>
                  {/* <TableCell>{item.DESCRIPTION}</TableCell> */}
                  <TableCell align="center" className="text-right">{item.QTY}</TableCell>
                </TableRow>
              ))}
              {ingredients.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No ingredients available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" sx={{ textTransform: "capitalize" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewRecipe;
